import { render, staticRenderFns } from "./ed-designer-elements-tools.component.vue?vue&type=template&id=127d3aa4&scoped=true&"
import script from "./ed-designer-elements-tools.component.ts?vue&type=script&lang=ts&"
export * from "./ed-designer-elements-tools.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-designer-elements-tools.component.scss?vue&type=style&index=0&id=127d3aa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127d3aa4",
  null
  
)

export default component.exports